import { render, staticRenderFns } from "./CecosYafesIndex.vue?vue&type=template&id=4cf88fa9"
import script from "./CecosYafesIndex.vue?vue&type=script&lang=js"
export * from "./CecosYafesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports